document.addEventListener('DOMContentLoaded', function () {
  initRsReveal();
});

function initRsReveal() {
  var items = document.querySelectorAll('.rs-reveal');
  if (!items.length) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    items.forEach(function (el) {
      el.classList.add('rs-visible');
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('rs-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15 }
  );

  items.forEach(function (el, i) {
    el.style.setProperty('--rs-i', i % 6);
    observer.observe(el);
  });
}
